export default __webpack_public_path__ + "static/media/blend.1c1401b3.png";